import CompressorJs from 'compressorjs';

import { environment } from '../../../environment';

import type { Compressor } from '../types/compressor.type';

export const imageCompressor: Compressor = {
  compress(file: File) {
    return new Promise<File>((resolve, reject) => {
      new CompressorJs(file, {
        quality: environment.imageCompressorQuality,
        success: (compressed: File | Blob) => {
          if (compressed instanceof File) {
            resolve(compressed);
          } else if (compressed instanceof Blob) {
            const compressedFile = new File([compressed], file.name, {
              type: compressed.type,
            });
            resolve(compressedFile);
          }
        },
        error: reject,
      });
    });
  },
};
